import * as libphonenumber from "libphonenumber-js";
import vars from "utils/vars";
import isStrongPassword from "validator/lib/isStrongPassword";

export const getPasswordMinLength = (isClinical = true) =>
	isClinical ? vars.app.passwordMinLengthClinical : vars.app.passwordMinLength;

export const isPasswordStrong = (value, { isClinical = true } = {}) =>
	Boolean(
		value &&
			isStrongPassword(value, {
				minLength: getPasswordMinLength(isClinical),
				minSymbols: 0,
			})
	);
export const objectToFormData = (obj, rootName, ignoreList, newFileName) => {
	var formData = new FormData();

	const ignore = (root) =>
		Array.isArray(ignoreList) &&
		ignoreList.some(function (x) {
			return x === root;
		});

	const appendFormData = (data, root) => {
		if (ignore(root)) return false;

		root = root || "";

		// Handle file types.
		if (data instanceof File) return formData.append(root, data, newFileName);
		// Handle array types.
		if (Array.isArray(data)) {
			if (!data?.length) return formData.append(root, "");
			return data.map((d, i) => appendFormData(d, `${root}[${i}]`));
		}
		// Handle object types.
		if (typeof data === "object" && data) {
			for (var key in data) {
				if (data.hasOwnProperty(key)) appendFormData(data[key], root === "" ? key : `${root}[${key}]`);
			}
			return;
		}
		// Handle the rest types without null or undefined.
		if (data !== null && typeof data !== "undefined") return formData.append(root, data);
	};

	appendFormData(obj, rootName);
	return formData;
};

export const shuffleArray = (arr = []) => {
	for (var i = arr.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * (i + 1));
		var temp = arr[i];
		arr[i] = arr[j];
		arr[j] = temp;
	}
	return arr;
};

export const generateRandomPassword = (pwdLen = 8) => {
	const numberChars = "0123456789";
	const upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const lowerChars = "abcdefghijklmnopqrstuvwxyz";
	const allChars = `${numberChars}${upperChars}${lowerChars}`;
	const randPasswordArray = Array(pwdLen);
	randPasswordArray[0] = numberChars;
	randPasswordArray[1] = upperChars;
	randPasswordArray[2] = lowerChars;
	return shuffleArray(randPasswordArray.fill(allChars, 3).map((x) => x[Math.floor(Math.random() * x.length)])).join(
		""
	);
};

export const isSameValueAsInitialValue = (v, init) => JSON.stringify(v) === JSON.stringify(init);

/**
 * Converts a Blob to a base64 string.
 * @param {Blob} blob - The blob to convert.
 * @returns {Promise<string>} A promise that resolves with the base64 string.
 * @throws {Error} If the blob is not a Blob.
 */
export const blobToBase64 = (blob) => {
	// Check if the blob is a Blob
	if (blob === null || blob === undefined) return "";
	if (!(blob instanceof Blob)) {
		throw new Error(
			"blobToBase64: blob is not a Blob. Make sure to pass a Blob, not a File or other type of object."
		);
	}

	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		// Set up event listeners
		reader.onloadend = () => {
			// Resolve the promise with the base64 string
			resolve(reader.result);
		};

		reader.onerror = (error) => {
			// Reject the promise with the error
			reject(error);
		};

		// Start the conversion
		reader.readAsDataURL(blob);
	});
};

export const prepareMobileForVerification = (mobile = "") => {
	if (!mobile) return "";
	// Changing mobile format from "+1 (123) 456-7890" to "11234567890"
	const mobileNumberFormatted = libphonenumber.parsePhoneNumber(mobile);
	return `${mobileNumberFormatted.countryCallingCode}${mobileNumberFormatted.nationalNumber}`;
};
